<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '34rem', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '95vw' }"
  [header]="titleKey | translateKey"
>
  <div class="py-2">
    <p class="text-sm leading-6 text-slate-700">
      {{ messageKey | translateKey }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <p-button
        type="button"
        icon="pi pi-check"
        [label]="languageKey.I_UNDERSTAND | translateKey"
        (click)="confirm()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
